export const MODALS_NAMES = {
  modalUser: 'modalUser',
  modalCreateTask: 'modalCreateTask',
  modalPayCertificateOrDeposit: 'modalPayCertificateOrDeposit',
  modalComment: 'modalComment',
  modalPhoneCall: 'modalPhoneCall',
  modalCommentChange: 'modalCommentChange',
  modalExitTimeChange: 'modalExitTimeChange',
  modalEntryTimeChange: 'modalEntryTimeChange'
}
